const navigation = document.querySelector('.navigation');
const actionMenu = document.querySelector('.action--menu');
const navigationMenu = document.querySelector('.navigation__menu');

if (actionMenu && navigationMenu) {
  const menuItems = navigationMenu.querySelectorAll('.menu-item-has-children > a');

  actionMenu.addEventListener('click', e => {
    e.preventDefault();
    navigation.classList.toggle('active');
    actionMenu.classList.toggle('open');
    navigationMenu.classList.toggle('active');

    // Update the aria-label based on the state
    if (actionMenu.classList.contains('open')) {
      actionMenu.setAttribute('aria-label', 'Close Menu');
    } else {
      actionMenu.setAttribute('aria-label', 'Open Menu');
    }

    menuItems.forEach(menuItem => {
      menuItem.parentElement.classList.remove('active');
    });
  });

  document.addEventListener('click', (e) => {
    // Check if the click is outside the navigation menu and the action menu
    if (!navigationMenu.contains(e.target) && !actionMenu.contains(e.target)) {
      // Only trigger the actionMenu click if the navigation menu is active (open)
      if (navigationMenu.classList.contains('active')) {
        actionMenu.click();
      }
    }
  });

  // Attach click event to each menu item
  menuItems.forEach(menuItem => {
    menuItem.addEventListener('click', e => {
      if (window.innerWidth <= 1279) {
        e.preventDefault();
      }
      menuItem.parentElement.classList.add('active');
    });
  });

  // Function to update (add or remove) back buttons based on screen width
  // Add or remove contextual “back” links depending on screen width
  const updateBackButtons = () => {
    menuItems.forEach(menuItem => {
      const submenu = menuItem.parentElement.querySelector('.sub-menu');
      if (!submenu) return;

      if (window.innerWidth <= 1279) {
        // Only add if we haven’t already
        if (!submenu.querySelector('.navigation__back')) {
          const parentTitle = menuItem.querySelector('.navigation__label').textContent.trim();
          submenu.insertAdjacentHTML(
            'afterbegin',
            `<li class="navigation__back">
              <a href="#">
                <i class="icon icon--chevron"></i>
                <span>${parentTitle}</span>
              </a>
            </li>`
          );

          submenu.querySelector('.navigation__back a')
            .addEventListener('click', e => {
              e.preventDefault();
              menuItem.parentElement.classList.remove('active'); // close submenu
            });
        }
      } else {
        // On larger screens remove the injected item
        const backButton = submenu.querySelector('.navigation__back');
        if (backButton) backButton.remove();
      }
    });
  };

  // Initialize back buttons and update on window resize
  updateBackButtons();
  window.addEventListener('resize', updateBackButtons);
}